import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingService } from './setting.service';
import { Observable } from 'rxjs';
import { ApiControllerService } from './api-controller.service';

export interface IGeolocationRequest {
  latitude: number;
  longitude: number;
}

export interface IGeolocationResponse {
  suburb: string;
  city: string;
  state: string;
  country: string;
  country_code: string;
}

@Injectable({
  providedIn: 'root',
})
export class GeolocationService {
  
  constructor(
    private http: HttpClient, 
    private setting: SettingService,
    private apiController: ApiControllerService
  ) { }

  getGeoData(GeoRequest: IGeolocationRequest): Observable<IGeolocationResponse> {
    const geodataStr  = localStorage.getItem('savedGeoLocation');
    const geodata = geodataStr ? JSON.parse(geodataStr) : null;

    return Observable.create(o => {
      if (!geodata) {
        /* this.http.post(this.setting.apiUrl('Geolocation/GetAddressLocation'), GeoRequest)
          .subscribe((data: any) => {

            localStorage.setItem('savedGeoLocation', JSON.stringify(data));
            o.next(data);
            o.complete();
          }); */
        this.apiController.post(this.setting.apiUrl('Geolocation/GetAddressLocation'), GeoRequest)
          .subscribe((data: any) => {

            localStorage.setItem('savedGeoLocation', JSON.stringify(data));
            o.next(data);
            o.complete();
          });

      } else {
        o.next(geodata);
        o.complete();
      }


    })
  }
}
